import './sentry/_sentry-helper';
import base from "./common/_base";
import confirm from "./common/_confirm";
import customModal from "./common/_custom-modal";
import {loadAjax} from "./common/_ajax";

export default function(){
    base();
    confirm();
    customModal();
    loadAjax();
}